import React from 'react'

const VisPercent = ({
  homeColor = '',
  awayColor = '',
  homeValue = 0,
  awayValue = 0,
  homeText  = '',
  awayText  = '',
  large   = false
}) => {
  
  //const backgroundColor = ;
  if ( homeValue == 0 && awayValue == 0 ) {
    awayColor = '#e5e5e5'
  }

  return (
    <div className={'stat-graph compareLineGraph twoTeam largeLabels' + (large ? ' large' : '')}>
      <span className="chartValue">{homeText}</span>
      <div className="bar-wrap">
        <span style={{ backgroundColor:awayColor }} className="bar-total">
          <span style={{ backgroundColor: (homeValue > 100 ? awayColor : homeColor), width: homeValue+ '%' }} className="bar-percentage"></span>
        </span>
        <span className="chartValue">{awayText}</span>
      </div>
    </div>
  )

}

export default VisPercent



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/components/statistics/VisPercent.jsx